import Chip from '@mui/material/Chip'

import type { Styles } from '../../theme/types/Styles'
import { stringToColor } from '../util/color-util'

export { Label }

interface Props {
  text: string
  small?: boolean
  sx?: Styles
}

const Label = ({ text, small = false, sx }: Props) => {
  return (
    <Chip
      label={text}
      variant="outlined"
      sx={{
        borderColor: stringToColor(text),
        mr: 1,
        mt: 1,
        ...(small && {
          borderRadius: '11px',
          height: '22px',

          '& .MuiChip-label': {
            paddingTop: '2px',
            paddingLeft: '8px',
            paddingRight: '8px',
          },
        }),
        ...sx,
      }}
    />
  )
}
